import { FC, useState, useEffect } from 'react';
import {
  ClassicEditor as Editor,
  EventInfo,
  EditorConfig,

  Alignment,
  Bold,
  Clipboard,
  Essentials,
  GeneralHtmlSupport,
  Heading,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  ListProperties,
  Paragraph,
  RemoveFormat,
  Undo,
} from "ckeditor5";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import "./ckeditor5-premium-features.scss";
import "./VisualEditor.scss";
import { defaultHeading, defaultHTMLSupport, defaultLink, defaultList } from './PluginConfigs';

export type VisualEditorProps = {
  className?: string;
  data?: string;
  editorId?: string;
  onReady?: (editor: Editor) => void;
  onChange?: (event: EventInfo<string, unknown>, editor: Editor) => void;
  onBlur?: (event: EventInfo<string, unknown>, editor: Editor) => void;
  onFocus?: (event: EventInfo<string, unknown>, editor: Editor) => void;
};

const VisualEditor:FC<VisualEditorProps> = ({ className, data, onReady, onChange, onBlur, onFocus}) => {
  const [isLayoutReady, setIsLayoutReady] = useState(false);

  const config: EditorConfig = {
    plugins: [
      Alignment,
      Bold,
      Clipboard,
      Essentials,
      GeneralHtmlSupport,
      Heading,
      Indent,
      IndentBlock,
      Italic,
      Link,
      List,
      ListProperties,
      Paragraph,
      RemoveFormat,
      Undo,
    ],
    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "|",
        "alignment",
        "|",
        "outdent",
        "indent",
        "|",
        "bold",
        "italic",
        "removeFormat",
        "|",
        {
          label: "Lists",
          icon: false,
          items: ["bulletedList", "numberedList"],
        },
        "|",
        "link",
      ],
      shouldNotGroupWhenFull: true,
    },
    htmlSupport: defaultHTMLSupport,
    heading: defaultHeading,
    link: defaultLink,
    list: defaultList,
  }
  
  // Component has mounted check
  useEffect(() => {
    setIsLayoutReady(true);

    return () => {
      setIsLayoutReady(false);
    };
  }, [isLayoutReady]);

  return (
    <div className={`main-container ${className ?? ""}`}>
      <div className="editor-container__editor-wrapper w-100">
        <div className="editor-container__editor w-100">
          <div>
            {isLayoutReady && (
              <CKEditor
                editor={Editor}
                data={data}
                config={config}
                onReady={(editor) => {
                  onReady && onReady(editor);
                }}
                onChange={(event, editor) => {
                  onChange && onChange(event, editor);
                }}
                onBlur={(event, editor) => {
                  onBlur && onBlur(event, editor);
                }}
                onFocus={(event, editor) => {
                  onFocus && onFocus(event, editor);
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default VisualEditor;
